import { useState } from "react";

const useFormInput = (initialValues, onChange) => {
  const [values, setValues] = useState(initialValues);
  const setInitialValue = (key) => {
    setValues((prevValues) => {
      const updatedValues = { ...prevValues, [key]: "" };
      if (onChange) {
        onChange(updatedValues);
      }
      return updatedValues;
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => {
      const updatedValues = { ...prevValues, [name]: value };
      if (onChange) {
        onChange(updatedValues);
      }
      return updatedValues;
    });
  };

  return {
    values,
    handleChange,
    setInitialValue,
    setValues,
  };
};

export default useFormInput;
